/* eslint-disable @typescript-eslint/no-explicit-any */
export function updateNestedObject(obj: any, path: string, value: any) {
    const keys = path.split('.')

    // Helper to decide if a string key is a numeric array index
    const isNumericKey = (k: string) => /^\d+$/.test(k)

    const apply = (target: any, idx: number): any => {
        const key = keys[idx]
        const isLast = idx === keys.length - 1

        if (Array.isArray(target)) {
            const nextIndex = isNumericKey(key) ? Number(key) : NaN
            const clone = target.slice()

            if (isLast) {
                if (Number.isNaN(nextIndex)) {
                    // Not a numeric key; store as a property on array object (rare)
                    ;(clone as any)[key] = value
                    return clone
                }
                clone[nextIndex] = value
                return clone
            }

            const nextKey = keys[idx + 1]
            const existingChild = Number.isNaN(nextIndex) ? (clone as any)[key] : clone[nextIndex]
            const defaultChild = isNumericKey(nextKey) ? [] : {}
            const updatedChild = apply(existingChild ?? defaultChild, idx + 1)

            if (Number.isNaN(nextIndex)) {
                ;(clone as any)[key] = updatedChild
            } else {
                clone[nextIndex] = updatedChild
            }
            return clone
        }

        // Non-array object case (treat null/undefined as object)
        const base: any = target && typeof target === 'object' ? { ...target } : {}
        if (isLast) {
            base[key] = value
            return base
        }

        const nextKey = keys[idx + 1]
        const existingChild = base[key]
        const defaultChild = isNumericKey(nextKey) ? [] : {}
        base[key] = apply(existingChild ?? defaultChild, idx + 1)
        return base
    }

    return apply(obj, 0)
}
